/**
 * Type of financing termination.
 * tag: 788
 * @readonly
 * @enum {number} (int)
 */
export enum TerminationType {
  /** Overnight */
  Overnight = 1,
  /** Term */
  Term = 2,
  /** Flexible */
  Flexible = 3,
  /** Open */
  Open = 4,
}
